import { Parameter, Dependency, Step } from './../model/Plan';
import { Injectable } from '@angular/core';
import { SoftwareInventoryService } from './software-inventory.service';
import { tap, filter } from 'rxjs/operators';
import { DeploymentStepParameter, DeploymentStepParameterList } from '../model/SolutionInfo';

@Injectable({
  providedIn: 'root'
})
export class PlanCallbackService {

  constructor() {}

  // CONTENT SERVER CALLBACKS
  static isOTCSAgentBuild(parameters:Parameter): boolean {
    var isValidated = false;
        	
    if(parameters){
      var versionParam = parameters["cs.product.version"];
      
      if(versionParam !== 'undefined'){
        if(versionParam && versionParam.value){
          if(versionParam.value != ''){
            var versElements = versionParam.value.split('.');
            var major = parseInt(versElements[0]);
            var minor = parseInt(versElements[1]);
            var update = parseInt(versElements[2]);
            
            if(major <= 16){
              if(minor == 0){
                if(update < 10){
                  isValidated = true;
                }
              }
              if(minor == 2){
                if(update < 6){
                  isValidated = true;;
                }
              }
            }
          }
        }
      }
    }
    
    
    return isValidated;
  }

  static isExistingDBParameter(parameters:Parameter, dependency:Dependency): boolean {
    var isValidated = false;
        	
    if(parameters){
      var newExistingParam = parameters["cs.database.new.question"];
      
      if(newExistingParam && newExistingParam.value){
        if(newExistingParam.value != '' && (newExistingParam.value == "1" || newExistingParam.value == "2")){
          isValidated = true;
          dependency.value = newExistingParam.value;
        }
      }
    }
    
    return isValidated;
  }

  static isVersionSet(parameters:Parameter, dependency:Dependency): boolean {
    var isValidated = false;
        	
    if(parameters){
      var versionParam = parameters[dependency.name];
          
      if(versionParam !== 'undefined'){
        if(versionParam && versionParam.value){
          if(versionParam.value != ''){
              isValidated = true;
          }
        }
      }
    }

    return isValidated;
  }

  static getLangVersions(parameters:Parameter, softInvServ: SoftwareInventoryService, fieldToSet:string): any {
    softInvServ.getLanguagePackVersions(parameters.constraints).pipe(
      tap( response => {
        let optionList = [];
        for(var i = 0; i < response.body.length; i++){
          let option = {name: response.body[i],
                        value: response.body[i],
                        visible: true};
          optionList.push(option);
        }
        parameters[fieldToSet] = optionList;
      })
    ).subscribe();
  }

  static isOTCSVersionOrHigher(parameters: Parameter, dependency: Dependency) {
    var isValidated = false;

    if (parameters) {
      var versionParam = parameters["cs.product.version"];

      if (versionParam && versionParam.value && versionParam.value != '' &&
        dependency && dependency.value && dependency.value != '') {
        var versElements = versionParam.value.split('.');
        var expectedVersElements = dependency.value.split('.');
        var major = parseInt(versElements[0]);
        var minor = parseInt(versElements[1]);
        var expectedMajor = parseInt(expectedVersElements[0]);
        var expectedMinor = parseInt(expectedVersElements[1]);

        if (major > expectedMajor) {
          isValidated = true;
        } else if (major == expectedMajor && minor >= expectedMinor) {
          isValidated = true;
        }
      }
    }

    return isValidated;
  }

   // DIRECTORY SERVICES CALLBACKS
   static isLDAPHostNameRequired(parameters: Parameter) {
    var isValidated = false;
    
    if(parameters){
      var versionParam = parameters["otds.product.version"];
      
      if(versionParam && versionParam.value && versionParam.value != ''){
        var versElements = versionParam.value.split('.');
        var major = parseInt(versElements[0]);
        var minor = parseInt(versElements[1]);
        var update = versElements.length > 2 ? parseInt(versElements[2]) : 0;
    
        if(major > 16 && major < 22){
          isValidated = true;
        }else if (major == 16){
          if(minor == 4 && update >= 3){
            isValidated = true;
          }else if(minor > 4){
            isValidated = true;
          }
        }
      }
    }
    
    return isValidated;
  }

  static isLDAPRequired(parameters: Parameter) {
    var isValidated = false;
    
    if(parameters){
      var versionParam = parameters["otds.product.version"];
      
      if(versionParam && versionParam.value && versionParam.value != ''){
        if(versionParam.value != ''){
          var versElements = versionParam.value.split('.');
          var major = parseInt(versElements[0]);
          var minor = parseInt(versElements[1]);
          var update = versElements.length > 2 ? parseInt(versElements[2]) : 0;
      
          if(major < 22){
            isValidated = true;
          }
        }
      }
    }
    
    
    return isValidated;
  }

  static isOTDSDatabaseVersion(parameters: Parameter) {
    var isValidated = false;
        
        if(parameters){
          var versionParam = parameters["otds.product.version"];
          
          if(versionParam && versionParam.value && versionParam.value != ''){
            var versElements = versionParam.value.split('.');
            var major = parseInt(versElements[0]);
            
            if(major > 21){
              isValidated = true;
            }
          }
        }
    return isValidated;
  }

  //LDIF import is no longer supported starting OTDS 22.x
  static isLDIFSupported(parameters: Parameter) {
    let isSupported:boolean = false;
    
    if(parameters){
      var versionParam = parameters["otds.product.version"];
      
      if(versionParam && versionParam.value && versionParam.value != ''){
        if(versionParam.value != ''){
          var versElements = versionParam.value.split('.');
          var major = parseInt(versElements[0]);
      
          if(major < 22){
            isSupported = true;
          }
        }
      }
    }
    
    return isSupported;
  }

  //is import data supported OTDS 22.x or later
  static isImportDataSupported(parameters: Parameter) {
    let isSupported:boolean = false;
    
    if(parameters){
      var versionParam = parameters["otds.product.version"];
      
      if(versionParam && versionParam.value && versionParam.value != ''){
        if(versionParam.value != ''){
          var versElements = versionParam.value.split('.');
          var major = parseInt(versElements[0]);
      
          if(major >= 22){
            isSupported = true;
          }
        }
      }
    }
    
    return isSupported;
  }

  //is import data checkbox selected
  static isImportDataSelected(parameters: Parameter, dependency: Dependency, service:string) {
    var isSelected = false;

    if (parameters) {
      var servicesParam = parameters[dependency.name];

      if (servicesParam && servicesParam.valueList && servicesParam.valueList.length > 0) {
        isSelected = servicesParam.valueList.filter( l => {return l.name == service && l.selected;}).length > 0;
      }
    }

    return isSelected && PlanCallbackService.isImportDataSupported(parameters);
  }
  
  //INTELLIGENT VIEWING
  static isViewingServiceSelected(parameters: Parameter, dependency: Dependency, service:string) {
    var isSelected = false;

    if (parameters) {
      var servicesParam = parameters[dependency.name];

      if (servicesParam && servicesParam.valueList && servicesParam.valueList.length > 0) {
        isSelected = servicesParam.valueList.filter( l => {return l.name == service && l.selected;}).length > 0;
      }
    }

    return isSelected;
  }

  static isVersionOrHigher(parameters: Parameter, dependency: Dependency) {
    var isValidated = false;

    if (parameters) {
      var versionParam = parameters["iv.product.version"];

      if (versionParam && versionParam.value && versionParam.value != '' &&
        dependency && dependency.value && dependency.value != '' ) {
        var versElements = versionParam.value.split('.');
        var expectedVersElements = dependency.value.split('.');
        var major = parseInt(versElements[0]);
        var minor = parseInt(versElements[1]);
        var expectedMajor = parseInt(expectedVersElements[0]);
        var expectedMinor = parseInt(expectedVersElements[1]);
       
        if (major > expectedMajor) {
          isValidated = true;
        } else if (major == expectedMajor && minor >= expectedMinor){
          isValidated = true;
        }
      }
    }

    return isValidated;
  }

  static isVersionOrLower(parameters: Parameter, dependency: Dependency) {
    var isValidated = false;

    if (parameters) {
      var versionParam = parameters["iv.product.version"];

      if (versionParam && versionParam.value && versionParam.value != '' &&
        dependency && dependency.value && dependency.value != '' ) {
        var versElements = versionParam.value.split('.');
        var expectedVersElements = dependency.value.split('.');
        var major = parseInt(versElements[0]);
        var minor = parseInt(versElements[1]);
        var expectedMajor = parseInt(expectedVersElements[0]);
        var expectedMinor = parseInt(expectedVersElements[1]);
       
        if (major < expectedMajor) {
          isValidated = true;
        } else if (major == expectedMajor && minor <= expectedMinor){
          isValidated = true;
        }
      }
    }

    return isValidated;
  }

  static getEnvironmentAgents(step: Step, parameter: Parameter, context: any): DeploymentStepParameterList[] {
    let list : DeploymentStepParameterList[] = [];
    if(context.solutionInfo && context.solutionInfo.currentEnvironment.agents.length > 0){
      for(let i = 0; i < context.solutionInfo.currentEnvironment.agents.length; i++){
        let agent = context.solutionInfo.currentEnvironment.agents[i];
        let exists: boolean = false;
        let index: number = -1;

        if(parameter.valueList !== undefined && parameter.valueList.length > 0){
            for(let j = 0; j < parameter.valueList.length; j++){
              exists = (parameter.valueList[j].name == agent.systemName);
              if(exists){
                index = j;
                break;
              }
            }
        }

        if(exists){
          parameter.valueList[index].valid = true;
          parameter.valueList[index].data = agent;
          list.push(parameter.valueList[index]);
        } else {
          let param : DeploymentStepParameterList = {
            name: agent.systemName,
            description: "",
            selected: false,
            value: "",
            visible: true,
            data: agent,
            valid: true
          }
          list.push(param);

          if(step.tabTemplate){
            for(let value of Object.values(step.tabTemplate)){
              let agentParam = JSON.parse(JSON.stringify(value));
              agentParam.group = agent.systemName;
              agentParam.visible = false;
              step.parameters[agentParam.name + "." + i] = agentParam;
            }
          }
        }
      }
    }

    //check for selected but removed systems
    if(parameter.valueList != undefined && parameter.valueList.length > 0){
      for(let i = 0; i < parameter.valueList.length; i++){
        if(parameter.valueList[i].selected){
          let found: boolean = false;
          for(let j = 0; j < list.length; j++){
            if(parameter.valueList[i].name == list[j].name){
              found = true;
              break;
            }
          }

          if(!found){
            parameter.valueList[i].valid = false;
            list.push(parameter.valueList[i]);
          }
        }
      }
    }

    return list;
  }

  static getSystemsTabs(step: Step, parameter: Parameter) {
    for(let valKey of Object.keys(parameter.valueList)) {
      let paramVal = parameter.valueList[valKey];
      for (const [key, value] of Object.entries(step.parameters)) {
        let paramObj = step.parameters[key];
        if(paramObj.group == paramVal.name){
          paramObj.visible = paramVal.selected;
        }
      }
    }
  }

  static showIVOTDSField(parameters: Parameter) {
    let isValidated = false;

    if (parameters) {
      let otdsType: Parameter = parameters["iv.otds.new.existing"];

      if (otdsType && otdsType.value && otdsType.value != '') {
          isValidated = (otdsType.value == "0" || otdsType.value == "1");
      }
    }

    return isValidated;
  }

  //APPWORKS GATEWAY
  static isOTAGVersionEqualOrHigher(parameters: Parameter, dependency: Dependency) {
    var isValidated = false;

    if (parameters) {
      var versionParam = parameters["otag.product.version"];

      if (versionParam && versionParam.value && versionParam.value != '' &&
        dependency && dependency.value && dependency.value != '' ) {
        var versElements = versionParam.value.split('.');
        var expectedVersElements = dependency.value.split('.');
        var major = parseInt(versElements[0]);
        var minor = parseInt(versElements[1]);
        var expectedMajor = parseInt(expectedVersElements[0]);
        var expectedMinor = parseInt(expectedVersElements[1]);
       
        if (major > expectedMajor) {
          isValidated = true;
        } else if (major == expectedMajor && minor >= expectedMinor){
          isValidated = true;
        }
      }
    }

    return isValidated;
  }
}
